import $api from "@/zapi-frontend/shared/api/axios";
import { GetIntelligenceQuestionsSchema, TIntelligenceQuestions } from "../model/types";

export async function postGenerateQuestions(
  { projectId, chapterId }: { projectId: number; chapterId: number }
) {
  const response = await $api.post(`/intelligence/questions`, {
    projectId,
    projectChapterId: chapterId
  });
  const data = GetIntelligenceQuestionsSchema.parse(response.data as TIntelligenceQuestions);
  return data.questions;
}
